import React from 'react'
import CreditReportCard from './CreditReportCard'
import CreditReportCTA from './CreditReportCTA'
import { Card, CardContent, CardTitle, CardDescription } from '../ui/Card'

const PROFILE_REDIRECT_URL =
  '/my_dashboard?activeTab=profile&redirect_url=/my_dashboard?activeTab=credit_report'
const CREDIT_REPORT_URL = '/my_dashboard?activeTab=credit_report'

const ErrorCard = ({ title, message, buttonText, buttonUrl }) => (
  <Card id='credit-report-cta-error'>
    <CardContent>
      <CardTitle>
        <h2 className='mb-3'>{title}</h2>
      </CardTitle>
      <CardDescription>
        <p className='mb-4'>{message}</p>

        <a href={buttonUrl} className='btn btn-primary w-100 mb-3' rel='nofollow'>
          {buttonText}
        </a>
      </CardDescription>
    </CardContent>
  </Card>
)

const MissingMetadataCard = () => (
  <Card id='credit-report-cta'>
    <CardContent>
      <CardTitle>
        <h2 className='mb-3'>Find hidden debt in collections.</h2>
      </CardTitle>
      <CardDescription>
        <p className='mb-4'>
          Most people being sued for a debt have 4 other accounts in collections. We can help you
          settle every one.
        </p>

        <a href={PROFILE_REDIRECT_URL} className='btn btn-primary w-100 mb-3' rel='nofollow'>
          See my credit report
        </a>

        <p className='text-muted small mb-0'>
          This won't affect your credit score. By clicking continue, you agree to a soft-credit pull
          as stated in our Terms of Service.
        </p>
      </CardDescription>
    </CardContent>
  </Card>
)

const CreditReport = ({ creditReport }) => {
  switch (creditReport.status) {
    case 'error':
      return (
        <ErrorCard
          title="Sorry, we couldn't fetch your credit report."
          message='Please double-check your profile information. If everything looks correct, contact support for assistance.'
          buttonText='Go to profile'
          buttonUrl={PROFILE_REDIRECT_URL}
        />
      )
    case 'available':
      return <CreditReportCard creditReport={creditReport.base_report} />
    case 'missing_metadata':
      return <MissingMetadataCard />
    case 'consent_required':
      return <CreditReportCTA />
    case 'fetching':
      // If fetching with no base report yet
      if (!creditReport.base_report) {
        return (
          <ErrorCard
            title='Your credit report is being fetched!'
            message='Please check back in a few minutes.'
            buttonText='Refresh'
            buttonUrl={CREDIT_REPORT_URL}
          />
        )
      }

      if (creditReport.base_report?.error) {
        return (
          <ErrorCard
            title="Sorry, we couldn't fetch your credit report."
            message='Please double-check your profile information. If everything looks correct, contact support for assistance.'
            buttonText='Go to profile'
            buttonUrl={PROFILE_REDIRECT_URL}
          />
        )
      }

      return <CreditReportCard creditReport={creditReport.base_report} />
    default:
      return null
  }
}

export default CreditReport
